(ns ballot-scout-v2-frontend.global-stats.views
  (:require [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
            [ballot-scout-v2-frontend.global-stats.events :as e.global-stats]
            [ballot-scout-v2-frontend.global-stats.subs :as s.global-stats]
            [ballot-scout-v2-frontend.subs :as subs]
            [ballot-scout-v2-frontend.util :as util]
            [re-frame.core :as rf]))

(defn ballot-stats []
  (let [stats @(rf/subscribe [::s.global-stats/ballot-stats])]
    [:div
     (if (= stats :loading)
       [:div.loading.columns.is-centered
        [:img.is-centered.p-2 {:src "/images/compass-100x100.png"}]]

       [:div.tile.is-ancestor.is-vertical
        [:div.tile.is-parent
         [:div.tile.is-child.is-3
          [:div.heading "Total ballot counts for all elections"]
          [:div.title (+ (-> stats
                             :active-ballots
                             first
                             :count)
                         (-> stats
                             :inactive-ballots
                             first
                             :count))]]

         [:div.tile.is-child.is-3
          [:div.heading "Active ballot counts for all elections"]
          [:div.title (-> stats
                          :active-ballots
                          first
                          :count)]]

         [:div.tile.is-child.is-3
          [:div.heading "Inactive ballot counts for all elections"]
          [:div.title (-> stats
                          :inactive-ballots
                          first
                          :count)]]]

        [:div.tile.is-parent
         [:div.tile.is-child.is-3
          [:div.heading "Active ballot counts for all upcoming elections"]
          [:div.title (-> stats
                          :active-ballots-per-upcoming-elections
                          first
                          :count)]]]

        [:div.tile.is-parent
         [:div.tile.is-child.is-3
          [:div.heading "Max active ballots x election"]
          [:div.title (-> stats
                          :max-active-ballots-x-election
                          first
                          :max)]]

         [:div.tile.is-child.is-3
          [:div.heading "Avg active ballots x election"]
          [:div.title (util/round (-> stats
                                      :avg-active-ballots-x-election
                                      first
                                      :avg))]]

         [:div.tile.is-child.is-3
          [:div.heading "Min active ballots x election"]
          [:div.title (-> stats
                          :min-active-ballots-x-election
                          first
                          :min)]]]

        [:div.tile.is-parent.is-12
         (let [ballots-by-election (:active-ballots-per-upcoming-elections-by-name stats)]
           [:div.tile.is-child
            [:div.heading "Active ballots by election"]
            [:div
             [:table.table.is-striped.is-bordered.is-narrow.stats-table
              [:tbody
               [:tr [:th "Partner"] [:th "Jurisdiction"] [:th "Election"] [:th "Election Date"] [:th "Count"]]
               (for [b ballots-by-election]
                 [:tr [:td (str (:partnername b))]
                  [:td (str (:juriname b))]
                  [:td (str (:ename b))]
                  [:td (str (:eldate b))]
                  [:td.has-text-right (str (:activecount b))]])]]]])]])]))

(defn dispo-stats []
  (let [stats @(rf/subscribe [::s.global-stats/dispo-stats])]
    [:div
     (if (= stats :loading)
       [:div.loading.columns.is-centered
        [:img.is-centered.p-2 {:src "/images/compass-100x100.png"}]]

       [:div.tile.is-ancestor.is-vertical
        [:div.tile.is-parent.is-vertical
         [:div.tile.is-child
          [:div.heading "Count of all Disposition updates"]
          [:div.title (or (-> stats
                              :count-all-disposition-updates
                              first
                              :count) 0)]]]

        [:div.tile.is-parent
         (let [dispo-count-by-status (-> stats :count-all-disposition-updates-by-status)]
           [:div.tile.is-child
            [:h3.heading
             [:div "Disposition Count by Status"]]
            (if (> (count dispo-count-by-status) 0)
              [:div
               [:table.table.is-striped.is-bordered.is-narrow.stats-table
                [:thead
                 [:tr
                  [:th "Status"] [:th "Count"]]]
                [:tbody
                 (for [b dispo-count-by-status]
                   [:tr
                    [:td (:status b)]
                    [:td.has-text-right (:count b)]])]]]
              [:div "No data."])])]])]))

(defn election-stats []
  (let [stats @(rf/subscribe [::s.global-stats/election-stats])
        all-by-date (-> stats :all-upcoming-elections-by-date)]
    [:div
     (if (= stats :loading)
       [:div.loading.columns.is-centered
        [:img.is-centered.p-2 {:src "/images/compass-100x100.png"}]]

       [:div.tile.is-ancestor.is-vertical
        [:div.tile.is-parent.is-vertical
         [:div.tile.is-child
          [:div.heading "Total elections in system"]
          [:div.title (-> stats
                          :all-elections-count
                          first
                          :count)]]
         [:div.tile.is-child
          [:div.heading "Count of upcoming elections"]
          [:div.title (-> stats
                          :all-upcoming-elections-count
                          first
                          :count)]]]

        [:div.tile.is-parent.is-12
         [:div.tile.is-child
          [:div.heading "Upcoming Elections by Date"]
          [:div
           [:table.table.is-striped.is-bordered.is-narrow.stats-table
            [:thead
             [:tr [:th "Date"] [:th "Partner"] [:th "Election"]]]
            [:tbody
             (for [e all-by-date]
               ^{:key (str "notytype-" (:election_date e) (:partner_name e))}
               [:tr
                [:td (:election_date e)]
                [:td (:partner_name e)]
                [:td (:election_name e)]])]]]]]])]))

(defn notys-stats []
  (let [stats @(rf/subscribe [::s.global-stats/notys-stats])]
    [:div
     (if (= stats :loading)
       [:div.loading.columns.is-centered
        [:img.is-centered.p-2 {:src "/images/compass-100x100.png"}]]

       [:div.tile.is-ancestor.is-vertical
        [:div.tile.is-parent
         [:div.tile.is-child
          [:div.heading "All notys sent"]
          [:div.title (max 0 (-> stats
                                 :count-all-notys
                                 first
                                 :count))]]]
        [:div.tile.is-parent
         (let [all-notys-by-medium (-> stats :count-all-notys-by-medium)]
           [:div.tile.is-child
            [:h3.heading
             [:div "All notys sent by medium"]]
            [:div
             [:table.table.is-striped.is-bordered.is-narrow.stats-table
              [:thead
               [:tr
                [:th "Medium"] [:th "Count"]]]
              [:tbody
               (for [b all-notys-by-medium]
                 [:tr
                  [:td (:medium b)]
                  [:td.has-text-right (:count b)]])]]]])]

        [:div.tile.is-parent
         (let [all-notys-by-type (-> stats :count-all-notys-by-type)]
           [:div.tile.is-child
            [:div.heading "All notys sent by type"]
            [:div
             [:table.table.is-striped.is-bordered.is-narrow.stats-table
              [:thead
               [:tr
                [:th "Type"] [:th "Count"]]]
              [:tbody
               (for [b all-notys-by-type]
                 ^{:key (str "notytype-" (:type b))}
                 [:tr
                  [:td (:type b)]
                  [:td.has-text-right (:count b)]])]]]])]

        [:div.tile.is-parent
         (let [all-notys-by-type (-> stats :count-all-notys-by-type-medium)]
           [:div.tile.is-child
            [:div.heading "All notys sent by type, medium"]
            [:div
             [:table.table.is-striped.is-bordered.is-narrow.stats-table
              [:thead [:tr [:th "Medium"] [:th "Type"] [:th "Count"]]
               (for [b all-notys-by-type]
                 [:tr
                  [:td (:medium b)]
                  [:td (:type b)]
                  [:td.has-text-right (:count b)]])]]]])]

        [:div.tile.is-parent
         (let [notys-by-election-medium (-> stats :count-all-notys-by-medium-election)]
           [:div.tile.is-child
            [:div.heading "All notys sent by election, medium"]

            (if (> (count notys-by-election-medium) 0)
              [:div
               [:table.table.is-striped.is-bordered.is-narrow.stats-table
                [:tr
                 [:th "Partner"] [:th "Jurisdiction"] [:th "Election"] [:th "Medium"] [:th "Count"]]
                (for [b notys-by-election-medium]
                  [:tr
                   [:td (:pname b)]
                   [:td (:jname b)]
                   [:td (:ename b)]
                   [:td (:medium b)]
                   [:td.has-text-right (:count b)]])]]
              [:div "No results."])])]

        [:div.tile.is-parent
         (let [notys-by-election-medium (-> stats :count-all-notys-by-type-election)]
           [:div.tile.is-child
            [:div.heading "All notys sent by election, type"]
            (if (> (count notys-by-election-medium) 0)
              [:div
               [:table.table.is-striped.is-bordered.is-narrow.stats-table
                [:tr [:th "Partner"] [:th "Jurisdiction"] [:th "Election"] [:th "Type"] [:th "Count"]]
                (for [b notys-by-election-medium]
                  [:tr
                   [:td (:pname b)]
                   [:td (:jname b)]
                   [:td (:ename b)]
                   [:td (:type b)]
                   [:td.has-text-right (:count b)]])]]
              [:div "No results."])])]])]))

(defn subs-stats []
  (let [stats @(rf/subscribe [::s.global-stats/subs-stats])]
    [:div
     (if (= stats :loading)
       [:div.loading.columns.is-centered
        [:img.is-centered.p-2 {:src "/images/compass-100x100.png"}]]

       [:div.tile.is-ancestor.is-vertical
        [:div.tile.is-parent.is-vertical
         [:div.tile.is-child
          [:div.heading "Total active subscriptions"]
          [:div.title (or (-> stats
                              :total-active-subs
                              first
                              :allsubs) 0)]]

         [:div.tile.is-child
          [:div.heading "Total active SMS subscriptions"]
          [:div.title (or (-> stats
                              :active-sms-subs
                              first
                              :count) 0)]]

         [:div.tile.is-child
          [:div.heading "Total active Email subscriptions"]
          [:div.title (or (-> stats
                              :active-email-subs
                              first
                              :count) 0)]]]

        [:div.tile.is-parent
         (let [subs-x-partner (-> stats :active-email-and-sms-subs-x-jurisdiction)]
           [:div.tile.is-child
            [:div.heading "Active subscriptions by Partner"]
            (if (> (count subs-x-partner) 0)
              [:div
               [:table.table.is-striped.is-bordered.is-narrow.stats-table
                [:thead [:tr [:th "Name"] [:th "Email Count"] [:th "SMS Count"] [:th "Total Count"]]]
                [:tbody
                 (for [b subs-x-partner]
                   ^{:key (str "substat-" (:name b))}
                   [:tr
                    [:td (:name b)]
                    [:td.has-text-right (:activeemail b)]
                    [:td.has-text-right (:activesms b)]
                    [:td.has-text-right (:allsubs b)]])]]]
              [:div "No results."])])]

        [:div.tile.is-parent
         (let [subs-x-juri (-> stats :active-email-and-sms-subs-x-jurisdiction)]
           [:div.tile.is-child
            [:div.heading "Active subscriptions by jurisdiction"]
            (if (> (count subs-x-juri) 0)
              [:div
               [:table.table.is-striped.is-bordered.is-narrow.stats-table
                [:thead [:tr [:th "Name"] [:th "Email Count"] [:th "SMS Count"] [:th "Total Count"]]]
                [:tbody
                 (for [b subs-x-juri]
                   ^{:key (str "substat-" (:name b))}
                   [:tr
                    [:td (:name b)]
                    [:td.has-text-right (:activeemail b)]
                    [:td.has-text-right (:activesms b)]
                    [:td.has-text-right (:allsubs b)]])]]]
              [:div "No results."])])]])]))

(defn usps-stats []
  (let [stats @(rf/subscribe [::s.global-stats/usps-stats])]
    [:div.container.is-centered
     (if (= stats :loading)
       [:div.loading.columns.is-centered
        [:img.is-centered.p-2 {:src "/images/compass-100x100.png"}]]

       [:div.tile.is-ancestor.is-vertical
        [:div.tile.is-parent.is-vertical
         [:div.tile.is-child
          [:div.heading "Count of all USPS scans"]
          [:div.title (or (-> stats
                              :count-all-usps-scans
                              first
                              :count) 0)]]
         [:div.tile.is-child
          [:div.heading "Avg USPS scans per day"]
          [:div.title (util/round (or (-> stats
                                          :avg-all-usps-scans-by-day
                                          first
                                          :avg) 0))]]

         [:div.tile.is-child
          [:div.heading "Avg USPS scans per mailpiece"]
          [:div.title (util/round (or (-> stats
                                          :average-scans-per-mailpiece
                                          first
                                          :avg) 0))]]]

        [:div.tile.is-parent.is-vertical
         (let [opcodes-x-partner (-> stats :opcodes-counts-by-partner)]
           [:div.tile.is-child
            [:div.heading "Opcodes By Partner"]
            (if (> (count opcodes-x-partner) 0)
              [:div
               [:table.table.is-striped.is-bordered.is-narrow.stats-table
                [:thead [:tr
                         [:th "Opcode"] [:th "Partner"] [:th "Count"]]]
                [:tbody
                 (for [c opcodes-x-partner]
                   ^{:key (str "substat-" (:name c))}
                   [:tr
                    [:td (:scan_code c)]
                    [:td (:name c)]
                    [:td.has-text-right (:count c)]])]]]
              [:div "No results."])])]])]))

(defn stats-tab-content [which-tab]
  [:section.tab-content
   (case which-tab
     :ballots [ballot-stats]
     :dispo [dispo-stats]
     :elections [election-stats]
     :notys [notys-stats]
     :subs [subs-stats]
     :usps [usps-stats]
     [:div (str "nothing found for " which-tab)])])

(defn switch-tab [tab-key]
  (rf/dispatch [:ballot-scout-v2-frontend.routes/navigate
                :ballot-scout-v2-frontend.routes/global-stats
                {:partner-slug @(rf/subscribe [::subs/current-partner-slug])}
                {:tab tab-key}]))

(defn tab-link [cur-tab tab-key label]
  [:li {:class ["px-2" (when (= cur-tab tab-key) "is-active")]}
   [:a {:class "p-0" :on-click #(switch-tab tab-key)}
    label]])

(defn divider [] [:div {:class "vl mx-2 is-hidden-mobile"}])

(defn global-stats []
  (fn []
    (when @(rf/subscribe [::subs/admin?])
      (let [url-state @(rf/subscribe [::subs/query-params])
            cur-tab (or (keyword (:tab url-state)) :ballots)]
        [:div {:class "global-stats"}
         [:h1 {:class ["heading-1" "home-view"]}
          "Statistics"]
         [:div {:class ["is-flex" "mt-4" "mb-6"]}
          [:div {:class ["tabs" "is-left" "is-small" "mb-0" "px-1"]}
           [:ul
            [tab-link cur-tab :ballots "Ballots"] [divider]
            [tab-link cur-tab :dispo "Dispo"] [divider]
            [tab-link cur-tab :elections "Elections"] [divider]
            [tab-link cur-tab :notys "Notifications"] [divider]
            [tab-link cur-tab :subs "Subscriptions"] [divider]
            [tab-link cur-tab :usps "USPS"]]]
          [:button
           {:class ["button" "is-primary" "ml-3"]
            :on-click #(rf/dispatch [::e.global-stats/fetch-stats cur-tab])}
           [icon ::icon/arrows-rotate]
           [:span.pl-3 "Refresh Data"]]]
         [:div
          [stats-tab-content cur-tab]]]))))

(defn page []
  [:div
   [global-stats]])
